import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'

import { apiZodios } from '~api/apiZodios'
import { GetIdentityViewRequestData } from '~types'

export const reduxApi = createApi({
  baseQuery: fakeBaseQuery(),
  endpoints: (build) => ({
    editPage: build.mutation({
      queryFn: async (args: Parameters<typeof apiZodios.ai_editPage>[0]) => {
        try {
          const data = await apiZodios.ai_editPage(args)
          return { data }
        } catch (error) {
          return { error }
        }
      },
    }),
    getIdentity: build.query({
      queryFn: async (args: GetIdentityViewRequestData) => {
        try {
          const data = await apiZodios.core_getIdentity(args)
          return { data }
        } catch (error) {
          return { error }
        }
      },
    }),
    listStaffers: build.query({
      queryFn: async (args: Parameters<typeof apiZodios.core_listStaffers>[0]) => {
        try {
          const data = await apiZodios.core_listStaffers(args)
          return { data }
        } catch (error) {
          return { error }
        }
      },
    }),
    listTags: build.query({
      queryFn: async (args: Parameters<typeof apiZodios.core_listTags>[0]) => {
        try {
          const data = await apiZodios.core_listTags(args)
          return { data }
        } catch (error) {
          return { error }
        }
      },
    }),
  }),
})

export const { useEditPageMutation, useGetIdentityQuery, useListStaffersQuery, useListTagsQuery } =
  reduxApi
